module.exports = __webpack_public_path__ + "static/media/pin.c206ec12.svg";